/*
 *
 * Api reducer
 *
 */

import produce from 'immer';
// import _ from 'lodash';

import { REQUEST_ACTIONS, REQUEST_ACTION, SET_SCROLL_POSITION } from './constants';
import { REQUEST_DATA_RESULT } from '../../containers/App/constants';

export const initialState = {
  actions: [],
  scrollPosition: 0,
};

export const actionReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case SET_SCROLL_POSITION:
        draft.scrollPosition = action.position;
        break;
      case REQUEST_DATA_RESULT:
        switch (action.id) {
          case REQUEST_ACTIONS:
            draft.actions = action.result;
            break;
          case REQUEST_ACTION:
            try {
              let index = draft.actions.indexOf(a => a.id === action.result.action.id);
              if (index === -1) draft.boards.push(action.result.action);
              else draft.boards[index] = action.result.action;
            } catch (e) {
              throw e;
            }
            break;
        }
    }
  });
